module.exports = __webpack_public_path__ + "img/waves.4b792304.svg";